
export class CuentaMatriculaModel {
  public identificacionAsociado: string = "";
  public nombreAsociado: string = "";
  public ip: string = "";
  public estadoAsociado: number = 0;
  public tipoCuenta: string = "";
  public numeroCuenta: string = "";
  public estadoReportOperacion: string = "";
  public emailAsociado: string = "";
  public tipoOperacion: number = 0;
  public codigoBanco: string = "";
  public numeroDeCedulaAsesor: string = "0";
}



// WEBPACK FOOTER //
// ./src/app/shared/models/cuenta-matricula-model.ts